/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/11/2022
 */

import React from "react";
import { Divider, IconButton, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SummaryForm from "./SummaryForm";
import { SummaryNotificationConfig } from "../../interfaces/Global";

export const defaultSummaryConfig: SummaryNotificationConfig = {
	version: "1",
	calendarId: 0,
	channel: null,
	daysOfWeek: ["Mo", "Tu", "We", "Th", "Fr"],
	times: ['10:00'],
	timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	employeesSource: "calendar",
	employeesFilter: [],
	includeUnavailable: true,
	includeAvailable: false,
	includeEventCategories: false,
	includeEventTypes: false,
	includeBirthdays: false,
	includeAnniversaries: false,
	eventCategories: [],
	eventTypes: [],
	employeeNameFormat: 'full',
	capacityFormat: 'headcount'
}

export default function NewSummary() {

	return (
		<Stack spacing={1} sx={{ p: 1 }}>
			<Stack direction={"row"} alignItems={"center"}>
				<IconButton size={"large"} to={"/notifications/summaries"} component={Link}>
					<ArrowBackIcon />
				</IconButton>
				<Stack>
					<Typography gutterBottom  variant="h4" sx={{ mb: 0, ml: 1 }}>
						New Summary Notification
					</Typography>
				</Stack>
			</Stack>
			<Divider />
			<SummaryForm
				config={defaultSummaryConfig}
			/>
		</Stack>
	);

}